import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import LoadingButton from "@mui/lab/LoadingButton"
import Grow from "@mui/material/Grow"
import CircularProgress from "@mui/material/CircularProgress"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"

export default withTranslation()(
  class DeleteExperienceDialog extends Component {
    state = { loading: false }

    deleteExperience = async (experienceId) => {
      const { setExperiences, experiences, close } = this.props

      this.setState({ loading: true })

      await fetch(
        `${
          process.env.REACT_APP_SERVER_URL
        }/experiences/${experienceId}?password=${localStorage.getItem(
          "password"
        )}`,
        {
          method: "DELETE",
          headers: {},
        }
      ).then(() => {
        setExperiences(experiences.filter(({ _id }) => _id !== experienceId))

        close()
      })

      this.setState({ loading: false })
    }

    componentWillReceiveProps(nextProps) {
      if (!this.props.open && nextProps.open) {
        this.setState({
          loading: false,
        })
      }
    }

    render() {
      const { open, close, t } = this.props
      const { loading } = this.state

      return (
        <Dialog
          open={open}
          onClose={close}
          TransitionComponent={Grow}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            className="notSelectable"
            style={{ fontWeight: 600 }}
          >{t`Delete experience`}</DialogTitle>
          <DialogContent style={{ paddingBottom: 0, textTransform: "none" }}>
            <DialogContentText>
              {t`Are you sure you want to permanently delete this experience?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={close}>{t`Close`}</Button>
            <LoadingButton
              loading={loading}
              loadingIndicator={<CircularProgress color="error" size={16} />}
              color="error"
              style={{ fontWeight: 600 }}
              onClick={() => {
                this.deleteExperience(
                  queryStringify.parse(window.location.search).experience
                )
              }}
            >{t`Delete`}</LoadingButton>
          </DialogActions>
        </Dialog>
      )
    }
  }
)
